'use strict';

/**
 *  Load modules
 */
import echo from './modules/echo.js';
import '../scss/app.scss';
$(document).ready(function () {
  echo('App ready');
  $('.references__list').slick({
    infinite: false,
    mobileFirst: true,
    dots: true,
    appendDots: $('.references__nav_dots'),
    prevArrow: $('.references__nav_prev'),
    nextArrow: $('.references__nav_next'),
    responsive: [{
      breakpoint: 768,
      settings: "unslick"
    }]
  });
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });

  // hide all contents except active ones on page load
  $(".features__accordion-item").each(function () {
    var $item = $(this);
    var $content = $item.find(".features__accordion-item-content");
    if ($item.hasClass("features__accordion-item_active")) {
      $content.show();
    } else {
      $content.hide();
    }
  });

  // click handler
  $(".features__accordion-item-header").on("click", function () {
    var $item = $(this).closest(".features__accordion-item");
    var $content = $item.find(".features__accordion-item-content");

    // if already active, close it
    if ($item.hasClass("features__accordion-item_active")) {
      $content.stop(true, true).slideUp(300);
      $item.removeClass("features__accordion-item_active");
    } else {
      // close others
      $(".features__accordion-item_active").removeClass("features__accordion-item_active").find(".features__accordion-item-content").stop(true, true).slideUp(300);

      // open clicked
      $item.addClass("features__accordion-item_active");
      $content.stop(true, true).slideDown(300);
    }
  });

  /*Project show*/
  var $items = $(".references__list .references__item");
  var visibleCount = 4;
  if ($(window).width() <= 768) {
    visibleCount = 999;
  }

  // hide items after the first 4
  $items.slice(visibleCount).addClass("references__item_hidden").hide();

  // click handler
  $(".references__link > a").on("click", function (e) {
    e.preventDefault();

    // show all hidden items with animation
    $(".references__item_hidden").removeClass("references__item_hidden").slideDown(300);

    // optionally hide the link after showing
    $(this).parent(".references__link").fadeOut(200);
  });

  /*Fixing menu*/
  var $menus = $('.hero__menu_desktop, .hero__menu_mobile');
  var fixedClass = 'hero__menu--fixed';
  var ticking = false;
  function calcOffsets() {
    $menus.each(function () {
      var $m = $(this);
      // Remove fixed state temporarily so measurements are of natural flow
      $m.removeClass(fixedClass).css({
        width: '',
        left: ''
      });
      var visible = $m.is(':visible');
      if (visible) {
        $m.data('origOffsetTop', $m.offset().top);
        $m.data('origLeft', $m.offset().left);
        $m.data('origWidth', $m.outerWidth());
        $m.data('origHeight', $m.outerHeight());
      } else {
        $m.data('origOffsetTop', null);
      }

      // remove any leftover placeholder
      var ph = $m.data('placeholder');
      if (ph) {
        ph.remove();
        $m.removeData('placeholder');
      }
    });
  }
  function onScroll() {
    var scrollTop = $(window).scrollTop();
    $menus.each(function () {
      var $m = $(this);
      var origTop = $m.data('origOffsetTop');
      if (!origTop) return; // not present / hidden

      if (scrollTop + 50 >= origTop) {
        if (!$m.hasClass(fixedClass)) {
          // create placeholder to keep layout height
          var $ph = $('<div class="hero__menu-placeholder" aria-hidden="true"></div>').height($m.outerHeight());
          $m.after($ph);
          $m.data('placeholder', $ph);

          // lock width/left measured earlier and add fixed class
          $m.css({
            //width: $m.data('origWidth'),
            left: $m.data('origLeft')
          }).addClass(fixedClass);
        }
      } else {
        if ($m.hasClass(fixedClass)) {
          $m.removeClass(fixedClass).css({
            width: '',
            left: ''
          });
          var ph = $m.data('placeholder');
          if (ph) {
            ph.remove();
            $m.removeData('placeholder');
          }
        }
      }
    });
  }

  // throttle scroll with rAF
  $(window).on('scroll', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        onScroll();
        ticking = false;
      });
    }
  });

  // recalc on resize (remove fixed state first), then trigger scroll check
  $(window).on('resize', function () {
    // remove fixed states & placeholders so we measure natural layout
    $menus.each(function () {
      var $m = $(this);
      $m.removeClass(fixedClass).css({
        width: '',
        left: ''
      });
      var ph = $m.data('placeholder');
      if (ph) {
        ph.remove();
        $m.removeData('placeholder');
      }
    });

    // recalc offsets after layout stabilizes
    // small timeout helps when resize triggers responsive CSS
    clearTimeout($.data(this, 'resizeTimer'));
    $.data(this, 'resizeTimer', setTimeout(function () {
      calcOffsets();
      onScroll();
    }, 80));
  });

  // init
  calcOffsets();
  onScroll();
});